<hb-modal-overlay
  class="modal--upgrade"
  [actionButtons]="actionButtons"
  [modalType]="modalOverlayType.continue"
  (buttonClickEmitter)="handleModalButtons($event)"
>
  <div class="upgrade-modal">
    <h6 class="typography-6 typography--bold">
      Para continuar es necesario actualizar a GBM+ Ilimitado
    </h6>
    <p class="typography--semibold">Beneficios de un perfil Ilimitado</p>
    <ul>
      <li>Sin límites de depósitos mensuales</li>
      <li>
        Acceso a <b>Trading USA</b>, inversión en acciones en el mercado
        estadounidense
      </li>
      <li>
        Depósitos programados para aportar a tus inversiones de forma automática
      </li>
    </ul>
  </div>
</hb-modal-overlay>
